module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaCAYAAABozQZiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC9SURBVHgBrdLdDYIwEMDxu0ZDfHSDxk3YwE10hD7ou6O4AavcBryhRgPSJkCAftw13BM0+f1zaQqwxZzuzUWbWkuMcvDWXKGDh9oXlSTgcPvDJyBQH9CSAA4f2rx62FU2YEPt91OSORIL5wRweSAJoO+QG/BibiCIOYEoTgWSOBZg4VCAjX0BBaJ5z/4Ea9fu3U9rY8m8sDUkcyDMhcm1YzCKUzCIOdCLuXCFJXCGpXDEOdCOe55qV5yl0M4fmGDW0YaIrDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/more.png
// module id = rziK
// module chunks = 1